import { TextField, InputAdornment, IconButton, FormHelperText, FormControl } from '@mui/material';
import { ReactComponent as ContentCopy } from '@/img/bookings/copy.svg';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

const SettlePaymentCopyLinkFilled = ({ link }) => {
	const { t } = useTranslation();
	const theme = useTheme();

	const handleCopyLink = () => {
		navigator?.clipboard?.writeText(link);
	};

	return (
		<div className="settle-payment-copy-link">
			<FormControl fullWidth className="payment-link">
				<FormHelperText id="outlined-helper-text">{t('PaymentLink')}</FormHelperText>

				<div className="copy-link full-width">
					<TextField
						className="input-link"
						variant="outlined"
						value={link}
						readOnly
						sx={{
							'& .MuiInputBase-root': {
								height: '42px',
								backgroundColor: theme.palette.blue.lightBlue,
							},
							'& .MuiInputBase-input': {
								textOverflow: 'ellipsis',
								overflow: 'hidden',
								whiteSpace: 'nowrap',
							},
						}}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton onClick={handleCopyLink} edge="end" disableRipple>
										<ContentCopy width={24} height={24} />
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
				</div>
			</FormControl>
		</div>
	);
};

export default SettlePaymentCopyLinkFilled;
